import { Component, OnDestroy, OnInit } from '@angular/core';
import { Oauth2Service } from '../oauth2.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OAuth2LogoutRequest } from '../../../sdk/hydra';
import { navigateToUrl } from '../utils';
import { ThemeToggleComponent } from '../../ui/theme-toggle/theme-toggle.component';


@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    imports: [ThemeToggleComponent],
    styleUrl: './logout.component.less'
})
export class LogoutComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  uiState: 'showConsent' | 'silent' | 'error' = 'silent';
  uiError!: string;

  logoutRequest!: OAuth2LogoutRequest;

  constructor(private oauth2Service: Oauth2Service,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    const paramMap = this.activatedRoute.snapshot.queryParamMap;
    const logoutChallenge = paramMap.get('logout_challenge') || undefined;
    if (!logoutChallenge) {
      this.uiState = 'error';
      this.uiError = 'logout_challenge is missing';
    } else {
      this.subscription.add(
        this.oauth2Service.getLogoutConsent(logoutChallenge)
          .subscribe({
            next: (oauth2ConsentRequest) => {
              this.logoutRequest = oauth2ConsentRequest;
              if (oauth2ConsentRequest.client?.skip_logout_consent) {
                this.accept();
              } else {
                this.uiState = 'showConsent';
              }
            },
            error: (err) => {
              this.uiError = err.error;
              this.uiState = 'error';
            }
          })
      )
    }
  }

  accept(): void {
    this.subscription.add(
      this.oauth2Service.acceptLogoutConsent(String(this.logoutRequest.challenge))
        .subscribe({
          next: (redirectTo) => {
            navigateToUrl(this.router, redirectTo).then(() => {});
          },
          error: (err) => {
            this.uiError = err.error;
            this.uiState = 'error';
          }
        })
    );
  }

  reject(): void {
    this.subscription.add(
      this.oauth2Service.rejectLogoutConsent(String(this.logoutRequest.challenge))
        .subscribe({
          next: (redirectTo) => {
            navigateToUrl(this.router, redirectTo).then(() => {});
          },
          error: (err) => {
            this.uiError = err.error;
            this.uiState = 'error';
          }
        })
    );
  }
}
